// extracted by mini-css-extract-plugin
module.exports = {"root":"index-module--root--7301x","logo":"index-module--logo--3U9PA","animate":"index-module--animate--1Eum4","textEnter":"index-module--textEnter--28Frk"};